<template>
    <v-row no-gutters>
        <v-col cols="12">
            <DomainBar :accountId="$route.params.accountId" :domain="$route.params.domain" class="mb-6"></DomainBar>
            <AccessDeniedOverlay v-if="forbiddenError"></AccessDeniedOverlay>
            <!-- hierarchical navigation -->
            <!-- <v-row justify="start" class="mt-2 mx-4">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                <p class="text-caption text-start">
                    <router-link :to="{ name: 'user-dashboard' }">Dashboard</router-link> &gt;
                    <router-link :to="{ name: 'user-account-list' }">Accounts</router-link> &gt;
                    <router-link :to="{ name: 'account-dashboard', params: { accountId: this.$route.params.accountId } }">{{ accountName }}</router-link> &gt;
                    <router-link :to="{ name: 'account-search-domain', params: { accountId: this.$route.params.accountId } }">Domains</router-link> &gt;
                    <router-link :to="{ name: 'account-view-domain', params: { accountId: this.$route.params.accountId, domain: this.$route.params.domain } }">{{ this.$route.params.domain }}</router-link>
                </p>
                </v-col>
            </v-row> -->
            <!-- <v-row justify="center" class="py-5 mt-2">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                <h1 class="text-h6 font-weight-light text-center">{{ this.$route.params.domain }}</h1>
                </v-col>
            </v-row> -->
            <v-row justify="center" class="py-5 px-10 mb-8">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">

                    <template v-if="domain">
                        <v-alert dense type="warning" border="left" elevation="2" class="mt-2" v-if="domain.status==='new' || domain.status === 'pending'">
                            <template #prepend>
                                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="white--text"/>
                            </template>
                            <v-row align="center">
                                <v-col class="grow">
                                    You must prove ownership of the domain before the DNS records will be published.
                                    <span v-if="domain.status === 'pending'">A verification request has already been started.</span>
                                    <!-- <router-link :to="{ name: 'account-edit-domain-verify', params: { accountId: this.$route.params.accountId, domain: this.$route.params.domain } }">Verify domain ownership</router-link> -->
                                </v-col>
                                <v-col class="shrink">
                                    <v-btn :to="{ name: 'account-edit-domain-verify', params: { accountId: this.$route.params.accountId, domain: this.$route.params.domain } }">Verify</v-btn>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </template>

                    <template v-if="nameserverStatus">
                        <v-alert dense type="warning" border="left" elevation="2" class="mt-2" v-if="nameserverStatus==='unassigned'">
                            <template #prepend>
                                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="white--text"/>
                            </template>
                            <!-- The domain is not assigned to your account. -->
                            <!-- TODO: this link doesn't look good, need to make it nicer. doesn't seem to be any color that looks good on the amber background?? -->
                            <!-- <router-link :to="{ name: 'account-create-domain', params: { accountId: this.$route.params.accountId }, query: { domain: this.$route.params.domain } }"><span class="green--text text--darken-2">Add this domain</span></router-link> -->
                            <v-row align="center" class="ml-1">
                                <v-col class="grow">
                                    The domain is not assigned to your account.
                                </v-col>
                                <v-col class="shrink">
                                    <v-btn color="white purple--text" :to="{ name: 'account-create-domain', params: { accountId: this.$route.params.accountId }, query: { domain: this.$route.params.domain } }">Add</v-btn>
                                </v-col>
                            </v-row>
                        </v-alert>
                        <v-alert dense type="warning" border="left" elevation="2" class="mt-2" v-if="nameserverStatus==='conflict'">
                            <template #prepend>
                                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="white--text"/>
                            </template>
                            <v-row align="center" class="ml-1">
                                <v-col class="grow">
                                    The domain is not assigned to your account.
                                    <!-- TODO: if you believe this is in error, you can start a dispute process -->
                                </v-col>
                                <!-- TODO: link to registrar's site? or link to another page that we have with more info, that will then link to registrar's site? -->
                                <!-- <v-col class="shrink">
                                    <v-btn :to="{ name: '?? dispute ??', params: { accountId: this.$route.params.accountId, domain: this.$route.params.domain } }">Dispute</v-btn>
                                </v-col> -->
                            </v-row>
                        </v-alert>
                        <v-alert dense type="warning" border="left" elevation="2" class="mt-2" v-if="nameserverStatus==='other' || nameserverStatus === 'pending'">
                            <v-row align="center">
                                <v-col class="grow">
                                    Nameserver settings at your domain registrar are not pointing to LibertyDNS.
                                    You can edit DNS records, but they will only be visible to queries directed at our servers specifically.
                                    <span v-if="nameserverStatus === 'pending'">Looks like nameservers are being changed, check again later for updates.</span>
                                    <!-- <router-link :to="{ name: 'account-edit-domain-verify', params: { accountId: this.$route.params.accountId, domain: this.$route.params.domain } }">Verify domain ownership</router-link> -->
                                </v-col>
                                <!-- TODO: link to registrar's site? or link to another page that we have with more info, that will then link to registrar's site? -->
                                <!-- <v-col class="shrink">
                                    <v-btn :to="{ name: 'account-edit-domain-verify', params: { accountId: this.$route.params.accountId, domain: this.$route.params.domain } }">Verify</v-btn>
                                </v-col> -->
                            </v-row>
                        </v-alert>
                    </template>

                    <!-- TODO: query dns records for this domain only; allow adding new records, editing existing records, deleting records -->
                    <v-card elevation="4" class="pa-0" v-if="dnsRecordList">
                        <!--
                        <v-system-bar>
                            <v-spacer/>
                            <template v-if="domain">
                                <template v-if="domain.status !== 'verified'">
                                    <v-tooltip top>
                                        <template #activator="{ on, attrs }">
                                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="amber--text" v-bind="attrs" v-on="on"/>
                                        </template>
                                        <span>Not verified</span>
                                    </v-tooltip>
                                </template>
                                <template v-if="domain.status === 'verified'">
                                    <v-tooltip top>
                                        <template #activator="{ on, attrs }">
                                            <font-awesome-icon :icon="['fas', 'check']" class="green--text" v-bind="attrs" v-on="on"/>
                                        </template>
                                        <span>Verified</span>
                                    </v-tooltip>
                                </template>
                            </template>
                            <template v-if="nameserverStatus">
                                <template v-if="nameserverStatus !== 'ready'">
                                    <v-tooltip top>
                                        <template #activator="{ on, attrs }">
                                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="amber--text" v-bind="attrs" v-on="on"/>
                                        </template>
                                        <span>Not ready - nameservers are not pointing to LibertyDNS</span>
                                    </v-tooltip>
                                </template>
                                <template v-if="nameserverStatus === 'ready'">
                                    <v-tooltip top>
                                        <template #activator="{ on, attrs }">
                                            <font-awesome-icon :icon="['fas', 'check']" class="green--text" v-bind="attrs" v-on="on"/>
                                        </template>
                                        <span>Ready</span>
                                    </v-tooltip>
                                </template>
                            </template>
                        </v-system-bar>
                        -->
                        <v-toolbar short flat :color="primaryColor" dark>
                            <v-toolbar-title>DNS Records</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template #activator="{ on, attrs }">
                                    <v-btn icon @click="createNewRecordDialog = true">
                                        <font-awesome-icon :icon="['fas', 'plus']" style="font-size: 20px;" fixed-width v-bind="attrs" v-on="on"></font-awesome-icon>
                                    </v-btn>
                                </template>
                                Create record
                            </v-tooltip>
                            <v-menu offset-y left open-on-click open-on-hover close-delay="100">
                                <template #activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <font-awesome-icon :icon="['far', 'ellipsis-v']" style="font-size: 20px;" fixed-width/>
                                    </v-btn>
                                </template>
                                <v-list class="ma-0 pa-0">
                                    <v-list-item-group>
                                    <v-list-item :to="{ name: 'account-view-domain', params: { accountId: this.$route.params.accountId, domain: this.$route.params.domain } }">
                                        <v-list-item-title>Manage Domain</v-list-item-title>
                                    </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-menu>
                        </v-toolbar>
                        <!-- <v-divider></v-divider> -->
                        <!-- <v-list dense nav>
                            <v-list-item v-if="dnsRecordList.length === 0">No domains yet.</v-list-item>
                            <v-list-item v-for="item in dnsRecordList" v-bind:key="item.id" class="my-2" @click="onClickItem(item.id)">
                                <v-list-item-content class="text-start">
                                    TBD record goes here {{ JSON.stringify(item) }}
                                </v-list-item-content>
                            </v-list-item>
                        </v-list> -->
                        <v-simple-table>
                            <template #default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                        Type
                                        </th>
                                        <th class="text-left">
                                        Key
                                        </th>
                                        <th class="text-left">
                                        Value
                                        </th>
                                        <th class="text-left">
                                        Refresh
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in dnsRecordList" :key="idx" :class="{ highlight: item.highlight }">
                                        <td class="text-left">
                                            {{ item.type }}
                                        </td>
                                        <td class="text-left">
                                            {{ item.key }}
                                        </td>
                                        <td class="text-left">
                                            <template v-if="item.priority">
                                                <v-tooltip top>
                                                    <template #activator="{ on, attrs }">
                                                        <span class="mr-2 font-weight-bold" v-bind="attrs" v-on="on">{{ item.priority }}</span>
                                                    </template>
                                                    Priority
                                                </v-tooltip>
                                            </template>
                                            <template v-if="item.tag">
                                                <v-tooltip top>
                                                    <template #activator="{ on, attrs }">
                                                        <span class="mr-2 font-weight-bold" v-bind="attrs" v-on="on">{{ item.tag }}</span>
                                                    </template>
                                                    Tag
                                                </v-tooltip>
                                            </template>
                                            <template v-if="item.flags">
                                                <v-tooltip top>
                                                    <template #activator="{ on, attrs }">
                                                        <span class="mr-2 font-weight-bold" v-bind="attrs" v-on="on">{{ item.flags }}</span>
                                                    </template>
                                                    Flags
                                                </v-tooltip>
                                            </template>
                                            {{ item.value }}
                                        </td>
                                        <td class="text-left">
                                            {{ item.ttl }}
                                        </td>
                                        <td class="text-right">
                                            <v-btn icon color="black" disabled v-if="item.readonly">
                                                <font-awesome-icon :icon="['fas', 'lock']" style="font-size: 12px;" fixed-width/>
                                            </v-btn>
                                            <!-- <span class="pr-2 mx-1 text-center">
                                            <font-awesome-icon :icon="['fas', 'lock']" size="1x" style="font-size: 12px;" fixed-width/>
                                            </span> -->
                                            <v-menu offset-y left v-if="!item.readonly || isPermitServiceAdmin">
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon color="purple" v-on="on">
                                                        <font-awesome-icon :icon="['far', 'ellipsis-v']" style="font-size: 20px;" fixed-width/>
                                                    </v-btn>
                                                </template>
                                                <v-list class="ma-0 pa-0">
                                                    <v-list-item-group>
                                                    <!-- <v-list-item @click="openEditRecordDialog(item)">
                                                        <v-list-item-title>Edit</v-list-item-title>
                                                    </v-list-item> -->
                                                    <v-list-item @click="openDeleteRecordDialog(item)">
                                                        <v-list-item-title class="red--text">Delete</v-list-item-title>
                                                    </v-list-item>
                                                    </v-list-item-group>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <p class="mt-6 mb-0 text-caption">
                        <router-link :to="{ name: 'account-view-whois', params: { accountId: this.$route.params.accountId }, query: { q: this.$route.params.domain } }">WHOIS info...</router-link>
                    </p>
                    <p class="mb-0 text-caption">
                        <router-link :to="{ name: 'account-view-nameservers', params: { accountId: this.$route.params.accountId }, query: { q: this.$route.params.domain } }">Authoritative nameservers...</router-link>
                    </p>
                    <!-- <template v-ifdev>
                    <p class="text-overline mt-12">Developer <font-awesome-icon :icon="['far', 'code']" class="grey--text"/></p>
                    <router-link :to="{ name: 'tbd' }">See TinyDNS format</router-link>
                    <v-expansion-panels tile>
                        <v-expansion-panel>
                            <v-expansion-panel-header>Developers</v-expansion-panel-header>
                            <v-expansion-panel-content class="text-start grey--text text--darken-2">
                                <p class="text-overline">Service name</p>
                                <p>asdfasdf</p>
                                <p class="text-overline">Service version</p>
                                <p>asdfasdfasdf</p>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    </template> -->
                </v-col>
            </v-row>
            <v-dialog v-model="createNewRecordDialog" max-width="600">
            <v-card tile elevation="4" class="pa-0" max-width="600">
                <v-toolbar short flat color="white">
                    <v-toolbar-title class="purple--text">Create new DNS record in {{ this.$route.params.domain }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="px-5 pt-4">
                <v-form @submit.prevent="createDnsRecord" @keyup.enter.native.prevent="createDnsRecord" class="px-2">
                    <v-row>
                    <v-select v-model="editableType" label="Type" outlined dense :items="dnsRecordTypeChoices"></v-select>
                    </v-row>
                    <template v-if="editableType === 'ANAME'">
                        <v-row>
                        <v-text-field v-model="editableKey" label="Key" outlined dense ref="editableKeyInput"></v-text-field>
                        </v-row>
                        <v-row>
                        <v-text-field v-model="editableValue" label="Value" outlined dense></v-text-field>
                        <!-- TODO: choose from dyanmic dns hosts they have in the account; for regular dns hosting customers these are theonly records we'll do ANAME for;  business users can have regular text input for any hostname they want us to monitor -->
                        <!-- <v-text-field v-model="editableRefresh" label="Refresh" outlined dense class="ml-4" style="max-width: 150px;"></v-text-field> -->
                        </v-row>
                    </template>
                    <template v-if="editableType !== 'ANAME'">
                        <v-row>
                        <v-text-field v-model="editableKey" label="Key" outlined dense ref="editableKeyInput"></v-text-field>
                        <v-text-field v-model="editablePriority" label="Priority" outlined dense class="ml-4" style="max-width: 75px;" v-if="editableType === 'MX'"></v-text-field>
                        <v-text-field v-model="editableTag" label="Tag" outlined dense class="ml-4" style="max-width: 75px;" v-if="editableType === 'CAA'"></v-text-field>
                        <v-text-field v-model="editableFlags" label="Flags"  outlined dense class="ml-4" style="max-width: 75px;" v-if="editableType === 'CAA'"></v-text-field>
                        </v-row>
                        <v-row>
                        <v-text-field v-model="editableValue" label="Value" outlined dense></v-text-field>
                        <v-text-field v-model="editableRefresh" label="Refresh" outlined dense class="ml-4" style="max-width: 150px;"></v-text-field>
                        </v-row>
                    </template>
                    <v-row v-if="isPermitServiceAdmin">
                    <v-checkbox v-model="editableReadonly">
                        <template v-slot:label>
                            <span class="mr-2">Locked</span> <font-awesome-icon :icon="['fas', 'id-badge']" class="purple--text"/>
                        </template>
                    </v-checkbox>
                    </v-row>
                </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="4" class="purple white--text" @click="createDnsRecord" :disabled="!isFormComplete">
                        <span>Create</span>
                    </v-btn>
                    <v-btn text color="grey" @click="createNewRecordDialog = false">
                        <span>Cancel</span>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
            </v-dialog>
            <v-dialog v-model="deleteRecordDialog" max-width="600">
            <v-card tile elevation="4" class="pa-0" max-width="600">
                <v-toolbar short flat color="white">
                    <v-toolbar-title class="purple--text">Delete existing DNS record in {{ this.$route.params.domain }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="px-5">
                    <p>Type: {{ editableType }}</p>
                    <p>Key: {{ editableKey }}</p>
                    <p>Value: {{ editableValue }}</p>
                    <p>Refresh: {{ editableRefresh }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn elevation="4" class="purple white--text" @click="deleteDnsRecord">
                        <span>Delete</span>
                    </v-btn>
                    <v-btn text color="grey" @click="deleteRecordDialog = false">
                        <span>Cancel</span>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>

<style scoped>
tr.highlight {
    background-color: #FFF59D; /* yellow lighten-3 */
}
/*
.v-alert__wrapper {
    height: 100%;
}
.v-alert__wrapper .v-alert__icon {
    margin-top: auto;
    margin-bottom: auto;
}
*/
</style>

<script>
import { mapState, mapGetters } from 'vuex';
import DomainBar from '@/components/DomainBar.vue';
import { isValidInteger } from '@/sdk/input';

export default {
    components: {
        DomainBar,
    },
    data: () => ({
        account: null,
        domain: null,
        nameserverList: null,
        nameserverStatus: null,
        dnsRecordList: null,
        error: null,
        forbiddenError: false,
        dnsRecordTypeChoices: [
            { value: 'A', text: 'IPv4 Address (A)' },
            { value: 'AAAA', text: 'IPv6 Address (AAAA)' },
            { value: 'TXT', text: 'Text (TXT)' },
            { value: 'SRV', text: 'Service (SRV)' },
            { value: 'CNAME', text: 'Canonical name (CNAME)' },
            { value: 'MX', text: 'Mail exchange (MX)' },
            { value: 'NS', text: 'Nameserver (NS)' },
            { value: 'CAA', text: 'Certificate authority (CAA)' },
        ],
        // create new record
        createNewRecordDialog: false,
        createDnsRecordTimestamp: null,
        deleteRecordDialog: false,
        editableType: null,
        editableKey: null,
        editableValue: null,
        editablePriority: null,
        editableTag: null,
        editableFlags: null,
        editableRefresh: null,
        editableReadonly: null,
    }),
    computed: {
        ...mapState({
            session: (state) => state.session,
            user: (state) => state.user,
            focus: (state) => state.focus,
        }),
        ...mapGetters({
            primaryColor: 'primaryColor',
        }),
        accountName() {
            return this.account?.name ?? 'Unknown';
        },
        isFormComplete() {
            if (this.editableType === 'MX') {
                return this.editableType && this.editableKey && this.editableValue && this.editableRefresh && this.editablePriority;
            }
            if (this.editableType === 'CAA') {
                return this.editableType && this.editableKey && this.editableValue && this.editableRefresh && this.editableTag && typeof this.editableFlags === 'string';
            }
            return this.editableType && this.editableKey && this.editableValue && this.editableRefresh;
        },
        isPermitServiceAdmin() {
            return Array.isArray(this.user?.permit?.role) && this.user.permit.role.includes('service-admin');
        },
    },
    watch: {
        createNewRecordDialog(newValue) {
            if (newValue) {
                // clear the form
                this.editableType = 'A';
                this.editableKey = null;
                this.editableValue = null;
                this.editablePriority = null;
                this.editableTag = null;
                this.editableFlags = null;
                this.editableRefresh = 3600;
                this.editableReadonly = null;
                setTimeout(() => { this.$nextTick(() => this.$refs.editableKeyInput.focus()); }, 1);
            }
        },
        editableType(newValue) {
            if (newValue === 'MX') {
                this.editablePriority = 10;
            }
            if (newValue === 'CAA') {
                this.editableTag = 'issue';
                this.editableFlags = '0';
            }
        },
        focus() {
            this.loadDnsRecords();
        },
    },
    methods: {
        async loadAccount() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadAccount: true });
                const response = await this.$client.account(this.$route.params.accountId).self.get();
                console.log(`account/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.account = response;
                } else {
                    // TODO: redirect back to account list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load account', err);
                if (err.response?.status === 403) {
                    this.forbiddenError = true;
                }
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadAccount: false });
            }
        },
        async loadDomain() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadDomain: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.get({ name: this.$route.params.domain });
                console.log(`domain/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.domain = response;
                } else {
                    // TODO: redirect back to domain list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load domain', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadDomain: false });
            }
        },
        async checkNameservers() {
            try {
                this.nameserverList = null;
                this.$store.commit('loading', { checkNameservers: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.checkNameservers({ domain: this.$route.params.domain });
                console.log(`checkNameservers response ${JSON.stringify(response)}`);
                if (Array.isArray(response?.list)) {
                    this.nameserverList = response.list;
                }
                if (typeof response.status === 'string') {
                    this.nameserverStatus = response.status;
                }
            } catch (err) {
                console.error('failed to check nameservers', err);
            } finally {
                this.$store.commit('loading', { checkNameservers: false });
            }
        },
        async loadDnsRecords() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadDnsRecords: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.searchDnsRecord({ domain: this.$route.params.domain });
                console.log(`account/dashboard.vue: response ${JSON.stringify(response)}`);
                if (typeof response === 'object' && Array.isArray(response.list)) {
                    // check if query parameters indicate to highlight any items by their type, key, and/or value; if multiple criteria specified, we highlight only the intersection
                    if (this.$route.query.type || this.$route.query.key || this.$route.query.value) {
                        for (let i = 0; i < response.list.length; i += 1) {
                            let eligible = true;
                            if (this.$route.query.type && response.list[i].type !== this.$route.query.type) {
                                eligible = false;
                            }
                            if (this.$route.query.key && response.list[i].key !== this.$route.query.key) {
                                eligible = false;
                            }
                            if (this.$route.query.value && response.list[i].value !== this.$route.query.value) {
                                eligible = false;
                            }
                            if (eligible) {
                                response.list[i].highlight = true;
                            }
                        }
                    }
                    this.dnsRecordList = response.list;
                } else {
                    // TODO: redirect back to account list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load dns records', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadDnsRecords: false });
            }
        },
        async createDnsRecord() {
            try {
                if (Number.isInteger(this.createDnsRecordTimestamp) && this.createDnsRecordTimestamp + 500 > Date.now()) {
                    return;
                }
                this.createDnsRecordTimestamp = Date.now();
                this.error = false;
                // check that ttl is a non-negative integer
                let ttl = this.editableRefresh;
                if (typeof ttl === 'string') {
                    if (!isValidInteger(ttl)) {
                        this.$bus.$emit('snackbar', { type: 'warning', headline: 'TTL must be a non-negative integer' });
                        return;
                    }
                    ttl = Number.parseInt(ttl, 10);
                }
                if (!Number.isInteger(ttl) || ttl < 0) {
                    this.$bus.$emit('snackbar', { type: 'warning', headline: 'TTL must be a non-negative integer' });
                    return;
                }
                this.$store.commit('loading', { createDnsRecord: true });
                const record = {
                    domain: this.$route.params.domain,
                    type: this.editableType,
                    key: this.editableKey,
                    value: this.editableValue,
                    ttl,
                    readonly: this.editableReadonly,
                };
                if (record.type === 'MX') {
                    // check that priority is a non-negative integer
                    let priority = this.editablePriority;
                    if (typeof priority === 'string') {
                        if (!isValidInteger(priority)) {
                            this.$bus.$emit('snackbar', { type: 'warning', headline: 'Priority must be a non-negative integer' });
                            return;
                        }
                        priority = Number.parseInt(priority, 10);
                    }
                    if (!Number.isInteger(priority) || priority < 0) {
                        this.$bus.$emit('snackbar', { type: 'warning', headline: 'Priority must be a non-negative integer' });
                        return;
                    }
                    record.priority = priority;
                }
                if (record.type === 'CAA') {
                    record.tag = this.editableTag;
                    record.flags = this.editableFlags;
                }
                const response = await this.$client.account(this.$route.params.accountId).domain.createDnsRecord(record);
                console.log(`account/dashboard.vue: response ${JSON.stringify(response)}`);
                if (typeof response === 'object' && response.isCreated) {
                    this.dnsRecordList.push(record);
                    this.createNewRecordDialog = false;
                } else {
                    this.error = true;
                    this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to create record' });
                }
            } catch (err) {
                console.error('failed to create dns record', err);
                this.error = true;
                this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to create record' });
            } finally {
                this.$store.commit('loading', { createDnsRecord: false });
            }
        },
        openDeleteRecordDialog(item) {
            this.editableType = item.type;
            this.editableKey = item.key;
            this.editableValue = item.value;
            this.editablePriority = null;
            this.editableTag = null;
            this.editableFlags = null;
            this.editableRefresh = item.ttl;
            this.deleteRecordDialog = true;
        },
        async deleteDnsRecord() {
            try {
                this.$store.commit('loading', { deleteDnsRecord: true });
                const match = {
                    domain: this.$route.params.domain,
                    type: this.editableType,
                    key: this.editableKey,
                    value: this.editableValue,
                };
                const response = await this.$client.account(this.$route.params.accountId).domain.deleteDnsRecord(match);
                console.log(`deleteDnsRecord: response ${JSON.stringify(response)}`);
                if (typeof response === 'object' && response.isDeleted) {
                    this.loadDnsRecords();
                } else {
                    this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to delete DNS record' });
                }
            } catch (err) {
                console.error('failed to create dns record', err);
                this.error = true;
                // TODO: show snackbar
            } finally {
                this.$store.commit('loading', { deleteDnsRecord: false });
                this.deleteRecordDialog = false;
            }
        },
    },
    mounted() {
        this.loadAccount();
        this.loadDomain();
        this.loadDnsRecords();
        this.checkNameservers();
    },
};
</script>
